import { CallPastMessage } from '@wui/im'

import { conversionFromNumberToTime } from '@/shared/utils/date-time'

/**
 * Вычисляет длительность звонка из события звонка
 * @param item - событие звонка
 * @returns строка с длительностью звонка в формате времени (например, "01:23")
 */

export const getCallDuration = (item: CallPastMessage): string => {
  if (item.event === 'appointment_end' && 'conferenceStatistic' in item && item.conferenceStatistic) {
    const { timestampStart, timestampStop } = item.conferenceStatistic
    if (Number.isFinite(timestampStart) && Number.isFinite(timestampStop) && timestampStart < timestampStop) {
      return conversionFromNumberToTime((timestampStop - timestampStart) * 1000).trim()
    }
    return ''
  }

  // Для обычных звонков используем свойство duration, если оно есть
  if ('duration' in item && typeof item.duration === 'number') {
    return conversionFromNumberToTime(item.duration)
  }

  return ''
}
